// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__34yuN","inner":"Footer_inner__2nZKA","nextIcon":"Footer_nextIcon__3xcyH","innerLeft":"Footer_innerLeft__29ZoU"};